module.exports = {
      id: "vikatan-play-usage",
      viewBox: "0 0 27.8 28.8",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#vikatan-play",
      toString: function () {
        return this.url;
      }
    }